import { HorarioAPI } from "@/api/horario.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Horario } from "@/models/horario";

const horarioApi = new HorarioAPI();

const findBy = (linhaId: number): AxiosObservable<Horario[]> => {
  return horarioApi.findBy(linhaId);
};

export default {
  findBy,
};
